const signatureRoutes = [
  {
    path: '/assinatura-digital',
    name: 'digital-signature',
    component: () => import('@/views/signature/SignatureScreen.view.vue'),
    meta: {
      header: {
        hidePreviousBtn: true,
        title: 'Assinatura Digital',
      },
    },
  },
  {
    path: '/confirmacao-assinatura-digital',
    name: 'loading-digital-signature',
    component: () => import('@/views/signature/SignatureLoadingScreen.view.vue'),
    meta: {
      disabledPageReloadGuard: true,
      publicRoute: true,
      header: {
        hidePreviousBtn: true,
      },
    },
  }
];

export default signatureRoutes;
